import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText } from '../../ui';
import { PublicProvider } from '../../../api/Providers';
import { BasicStarIcon } from '../../ui/Icons';
import { ClientProviderProfile } from '../../../api/ProfileClientView';
import { useGetProStylieAward } from '../../../modules/stylies/utils';

type StylieAwardProfileBannerProps = {
  profile: PublicProvider | ClientProviderProfile;
};

export const StylieAwardProfileBanner: React.FCWithChildren<StylieAwardProfileBannerProps> = ({
  profile,
}) => {
  const starSize = 16;
  const starInnerPadding = 6;
  const color = BrandColor.LightYellow;
  const {
    awardYear,
    awardData: awardBannerInfo,
    isLoading: isLoadingStylies,
  } = useGetProStylieAward(profile);

  if (isLoadingStylies || !awardBannerInfo.is_awardee) {
    return null;
  }
  const awardBannerType = awardBannerInfo.award_type;
  const awardBannerService = awardBannerInfo.award_service;
  return (
    <Box paddingY={12} color={BrandColor.BackInBlack} testID="stylie-award-profile-banner">
      <Inline justifyContent="center" alignItems="center">
        <Box paddingRight={starInnerPadding}>
          <BasicStarIcon color={color} width={starSize} height={starSize} />
        </Box>
        <BodyText color={color} weight="bold">{awardYear} Stylies </BodyText>
        <BodyText color={color}>{awardBannerType} Award</BodyText>
        { awardBannerService && (
          <BodyText color={color}>: {awardBannerService}</BodyText>
        )}
        <Box paddingLeft={starInnerPadding}>
          <BasicStarIcon color={color} width={starSize} height={starSize} />
        </Box>
      </Inline>
    </Box>
  );
};
